export default __webpack_public_path__ + "static/media/pricing-2.f13e64a9.svg";